import { render, staticRenderFns } from "./DateQuestion.vue?vue&type=template&id=6b53b673&"
import script from "./DateQuestion.vue?vue&type=script&lang=js&"
export * from "./DateQuestion.vue?vue&type=script&lang=js&"
import style0 from "./DateQuestion.vue?vue&type=style&index=0&id=6b53b673&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports